import React from 'react';

import NavigationDateRangeArea from '../../containers/navigation/NavigationDateRangeArea';
import GlobalFilterModal from '../../containers/common/GlobalFilterModal';
import NavigationExecutionArea from '../../containers/navigation/NavigationExecutionArea';
import Timezone from '../Timezone';
import SimpleNavigationBar from './SimpleNavigationBar';

const NavigationBar = ({ children, ...rest }) => (
  <SimpleNavigationBar>
    {children}
    <Timezone />
    <GlobalFilterModal />
    <NavigationDateRangeArea />
    <NavigationExecutionArea {...rest} />
  </SimpleNavigationBar>
);

export default NavigationBar;
